export function arrayColumn(array, columnName,condition) {
    return array.map(function(value,index) {
            return value[columnName];
    })
}

